import React, { useContext } from 'react';
import { VehicleContext } from '../../utils/vehicle-context';
import { useFeatureServices } from '../../use-feature-services';
import { Link } from 'react-router-dom';
import { createConfiguration, createConstantData, createPartner, createProcess } from '../../utils/get-tracking-event-data';
import { getLang } from '../../translations';
import { useDealersStore } from '../../utils/use-dealers-store';
import { VehicleData } from '../../types';

const VehicleDetail = ({children} : React.PropsWithChildren<{}>) => {
  const { tracking } = useFeatureServices();
  const vehicle = useContext(VehicleContext) as VehicleData;
  const { vin, dealer_id, stock_number } = vehicle;

  const { getDealer } = useDealersStore();
  const dealer = getDealer(dealer_id);
  const lang = getLang();
  const idno = vin ? vin : stock_number;

  return (
      <Link
        aria-hidden={true}
        style={{textDecoration: 'none', display: 'grid'}}
        to={`/details/${idno}`}
        onClick={(e) => {
          tracking.track('VWBasic_VehicleButton_Click', {
            ...createConstantData('VWBasic_VehicleButton_Click', vehicle.category),
            configuration: createConfiguration('VWBasic_VehicleButton_Click', vehicle, lang),
            partner: createPartner(dealer),
            process: createProcess("2A"),
            link: {
              url: e.currentTarget.href,
              name: e.currentTarget.innerText.trim()
            }
          });
        }}
      >
        {children}
      </Link>
  );
};

export default VehicleDetail;
